export const Of_Course = {
  body_background_color: '#C7373B',

  header_border_color: '#eee',

  logo_image_url: 'ofcourselemans/default.png',
  logo_height: 80,

  button_color: '#C7373B',
  button_hover_color: '#88080C',
  button_hover_text_color: '#FFF',
  button_outlined_hover_color: '#88080C',

  button_half_border_color: '#C7373B',

  text_font: `'Montserrat', sans-serif`,
  title_font: `'Montserrat', sans-serif`,

  footer_border_color: '#eee',
}

export const Notre_histoire_Le_Mans_Metropole = {
  ...Of_Course,
  body_background_color: '#FFE600',

  logo_image_url: 'ofcourselemans/metropole.png',
  logo_height: 150,

  button_color: '#FFE600',
  button_text_color: 'black',
  button_hover_color: '#E5CF00',
  button_hover_text_color: 'black',
  button_hover_border_color: '#E5CF00',

  button_outlined_text_color: '#E5CF00',
  button_outlined_hover_color: '#E5CF00',

  button_half_border_color: '#FFE600',
}

export const Notre_histoire_Le_Mans = {
  ...Notre_histoire_Le_Mans_Metropole,
  logo_image_url: 'ofcourselemans/lemans.png',
  logo_height: 200,
  header_no_margin: true,
}

export const Notre_histoire_Le_Mans_withoutnumbers = {
  ...Notre_histoire_Le_Mans,
  logo_image_url: 'ofcourselemans/lemans.png',
  card_header_margin_top: 30,
  token_hidden: true,
  number_hidden: true,
}
export const Of_Course_withoutnumbers = {
  ...Of_Course,
  token_hidden: true,
  number_hidden: true,
}